var localPageData = {
  props: {
    localPageData: {
      type: Object,
      required: false
    }
  },
  computed: {
    pageData: function pageData() {
      return this.localPageData || this.$xp.content.pageData;
    }
  }
};

var entry = {
  mixins: [localPageData],
  props: {
    entryData: {
      type: Object,
      required: true
    }
  }
};

//
var script = {
  mixins: [entry]
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "js-entry o-entry c-contact-entry" }, [
    _c("h3", { staticClass: "c-contact-entry__name" }, [
      _vm._v("\n        " + _vm._s(_vm.entryData.Json.Name) + "\n    ")
    ]),
    _vm._v(" "),
    _c("dl", { staticClass: "c-contact-entry__details" }, [
      _vm.entryData.Json.Phone
        ? _c("dt", [_vm._v(_vm._s(_vm.$t("global.phone")))])
        : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Phone
        ? _c("dd", [_vm._v(_vm._s(_vm.entryData.Json.Phone))])
        : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Mobile
        ? _c("dt", [_vm._v(_vm._s(_vm.$t("global.mobile")))])
        : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Mobile
        ? _c("dd", [_vm._v(_vm._s(_vm.entryData.Json.Mobile))])
        : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Fax ? _c("dt", [_vm._v("Fax")]) : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Fax
        ? _c("dd", [_vm._v(_vm._s(_vm.entryData.Json.Fax))])
        : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Email ? _c("dt", [_vm._v("Email")]) : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Email
        ? _c("dd", [_vm._v(_vm._s(_vm.entryData.Json.Email))])
        : _vm._e()
    ])
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=ContactEntry.js.map
